<div class="col-md-12 mb-2">
  <div class="row">
    <div class="d-flex w-100 banner-form _co-payer">
      <div class="flex-fill banner-form-fields">
        <label>{{ 'Payer' | translate | async}}</label>
        <div class="d-flex">
          @if (payerQuestion && payerId != '') {
            <kx-multiselect-dropdown class="flex-grow-1"
              [disabled]="checkUHID()" [placeholder]="'Select payer'" [questions]="payerQuestion" [settings]="payerQuestion.defaultsetting"
              [data]="payerQuestion.datasource"
              [ngModel]="billingModel.payerId != '' ? billingModel.payerId : payerId" (ngModelChange)="billingModel.payerId != '' ? billingModel.payerId : payerId = $event"
              (onDeSelect)="onPayerDeselect($event);" (onSelect)="onPayerSelect($event)">
            </kx-multiselect-dropdown>
          }

          <!-- <select class="form-control" [(ngModel)]="billingModel.payerId" (change)="changePayer($event);"
          [disabled]="checkUHID()">
          <option value="" [disabled]="true">{{ 'Select Payer Name' | translate | async}}</option>
          <option *ngFor="let payer of billingModel.getPayerData" [value]="payer.id">{{payer.payer_name}}
          </option>
        </select> -->
        @if (billingModel.payment_typeId != 'cash' && !this.isPayerRemoved) {
          <div class="pl-1">
            <button type="button" class="primary-btn" (click)="openPayerInput($event)"><i
            class="fa fa-plus-circle fa-1x pointer" aria-hidden="true"></i></button>
          </div>
        }
      </div>
    </div>
    <div class="flex-fill banner-form-fields">
      <label>{{ 'Facility' | translate | async}}</label>
      <div class="d-flex">
        @if (facilitySearchSelect.datasource && facilitySearchSelect.datasource.possible_value.length>0) {
          <kx-multiselect-dropdown tabindex="0" [disabled]="isFacilityDisabled || disableAll" #facilitySelector class="flex-grow-1"  [settings]="facilitySearchSelect.defaultsetting"
            [questions]="facilitySearchSelect.question" [setId]="'org_id'" [format]="facilitySearchSelect.question.format" name="facility"
            [placeholder]="'Select facility'" [value]="facilitySearchSelect" [(ngModel)]="facilityModel" [data]="facilitySearchSelect.datasource"
            (onSelect)="onItemSelectOfFacility($event)" (onDeSelect)="onFacilityDeselect($event);">
          </kx-multiselect-dropdown>
        }
      </div>
    </div>
    <div class="flex-fill banner-form-fields width_alignment">
      <label [ngClass]="threatingRequired?'required':''">{{ 'Treating Doctor' | translate | async}}</label>
      <div class="d-flex">
        <!-- Skeleton loader — shows while data is loading -->
        @if ((!treatingQuestion.datasource || treatingQuestion.datasource.possible_value.length === 0)) {
          <div class="skeleton-loader"></div>
        }
        @if (treatingQuestion.datasource && treatingQuestion.datasource.possible_value.length>0) {
          <kx-multiselect-dropdown tabindex="0" class="flex-grow-1" #treatingDcotorSelector [disabled]="false || disableAll"
            [placeholder]="'Select treating doctor'" [setId]="treatingQuestion.key"  [questions]="treatingQuestion" [settings]="treatingQuestion.defaultsetting"
            [data]="treatingQuestion.datasource"   [format]="treatingQuestion.format" [value]="treatingQuestion" [(ngModel)]="treatingDrModel"
            (onDeSelect)="onTreatingDoctorDeselect($event);" (onSelect)="onTreatingDoctorSelect($event)">
          </kx-multiselect-dropdown>
        }
      </div>
    </div>

    <!-- <div class="col-md-2 pr-0">
    <select class="form-control" [(ngModel)]="billingModel.schemeId">
      <option value="" [disabled]="true">Select Scheme Name</option>
      <option *ngFor="let scheme of billingModel.getSchemesData" [value]="scheme.id">{{scheme.name}}
      </option>
    </select>
  </div>-->
  <div class="flex-fill banner-form-fields">
    <label [ngClass]="refferedConfigReq?'required':''">{{ 'Refer Type' | translate | async}}</label>
    <div class="d-flex">
      @if (referTypeQuestion.datasource) {
        <kx-multiselect-dropdown tabindex="0" class="flex-grow-1" #referTypeSelector [disabled]="false || disableAll"
          [placeholder]="'Select Refer Type'" [setId]="referTypeQuestion.key"  [questions]="referTypeQuestion" [settings]="referTypeQuestion.defaultsetting"
          [data]="referTypeQuestion.datasource"   [format]="referTypeQuestion.format" [value]="referTypeQuestion" [(ngModel)]="billingModel.referType"
          (onSelect)="onReferTypeSelect($event)">
        </kx-multiselect-dropdown>
      }
    </div>

    <!-- <select class="form-control" [(ngModel)]="billingModel.referType" [disabled]="disableAll"
    (change)="getReferralNames($event.target.value);">
    <option value="" [disabled]="true">Select Refer Type</option>
    <option *ngFor="let refer of billingModel.getReferralTypes" [value]="refer.referType">
    {{refer.referType_name}}</option>
  </select> -->
</div>
<div class="flex-fill banner-form-fields">
  <label [ngClass]="refferedConfigReq?'required':''">{{ 'Referred By' | translate | async}}</label>
  @if (billingModel.isFacilityOrPerson !='Other') {
    <select class="form-control" [disabled]="disableAll"
      [(ngModel)]="billingModel.referredById" (change)="getReferByName($event);">
      <option value="" [disabled]="true">{{ 'Select Referred by' | translate | async}}</option>
      @for (refer of billingModel.getReferralNamesData; track refer) {
        <option [value]="refer.id">
        {{refer.firstName}}</option>
      }
    </select>
  }
  @if (billingModel.isFacilityOrPerson =='Other') {
    <input class="form-control" (change)="getReferByName($event)" [disabled]="disableAll"
      type="text" placeholder="Please enter refer by name" [(ngModel)]="billingModel.referred_by_name">
  }
</div>
</div>
</div>
</div>
